import { useTranslation } from 'react-i18next';
import ChatBubble from '../../../components/Chat/Chat';
import mascot from '../../../assets/designSystem/icons/StaticPages/Symptoms/Adult/correct.svg';

export default function CorrectAnswer({ answer }) {
  const { t } = useTranslation();
  return (
    <div className="congrats">
      <ChatBubble img={mascot} text={t('staticPages.signsAndSymptoms.adult.title2')} />
      <p style={{ textAlign: 'center' }}>{t(answer)}</p>
      <div className="congrats__footer" />
    </div>
  );
}
